export const DEFAULT_PAGE = 'main';
export const DEFAULT_FETCH_LIMIT = 30;
